import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { connect } from "react-redux";
import ProductItem from "./product-item";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getCurrencySymbol,
} from "../../../store";
import { getCall, postCall } from "../../../api/post";
import { isInquiryOrCart,setHeaderCounters } from "../../../actions";
import { Link, withRouter } from "react-router-dom";
import { getPincodeDeliveryUrl } from "../../../services";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import SuccessMessageAnimationModal from "../../../animation/SuccessMessageAnimationModal";
import NoSpecialProductFoundAnim from "../../../animation/NoSpecialProductFoundAnim";

import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
} from "../../../utils/utils";
import AddToWishListAnim from "../../../animation/AddToWishListAnim";

class SpecialProducts extends Component {
  state = {
    isPincodeDeliveryEnable: false,
    showErrorMessageModal: false,
    errorMessage: "",
    showSuccessMessageModal: false,
    successMessage: "",
    showAddToWishListMessageModal: false,

    addToWishListMessage: "",
  };

  componentDidMount() {
    const { masterDetailsObj } = this.props;
    this.props.isInquiryOrCart(masterDetailsObj);
    this.initPincodeDelivery();
  }

  initPincodeDelivery = async () => {
    const { masterDetailsObj } = this.props;

    const userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }
    const pincodeDeliveryUrl = getPincodeDeliveryUrl(masterDetailsObj);
    const pincodeDelivery = await getCall(pincodeDeliveryUrl, []);
    if (pincodeDelivery.error) {
      clearLocalStorageReload({ response: pincodeDelivery });
      this.loadErrorMessageAnimation(pincodeDelivery.error.message);
    } else {
      if (pincodeDelivery.length > 0) {
        const status = pincodeDelivery[0].status;
        this.setState({ isPincodeDeliveryEnable: status === 1 ? true : false });
      }
    }
  };

  fetchHeaderCounters = async () => {
  try {
    const response = await getCall("v2/dashboard/header-counters", []);
    if (response.error) {
      return;
    }
    this.props.setHeaderCounters(response); // <-- dispatch to Redux
  } catch (e) {}
};

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadSuccessMessageAnimation = (message) => {
    this.setState({ successMessage: message, showSuccessMessageModal: true });
  };

  loadAddToWishListMessageAnimation = (message) => {
    this.setState({
      addToWishListMessage: message,
      showAddToWishListMessageModal: true,
    });
  };

  addToCompareAPI = async (product) => {
    if (!product || !product.id) {
      console.error("Invalid product object passed to comparison");
      this.loadErrorMessageAnimation("Invalid product data.");
      return;
    }

    const body = {
      productId: product.id,
    };

    try {
      const response = await postCall("v2/product-comparisons", body);

      if (response && response.success) {
        console.log("Product added to comparison:", response.message);

        // Show a success message
        const successMessage =
          getValueFromLanguageObject("str_add_to_compare_successfully") ||
          response.message ||
          "Product added to compare successfully";
        this.loadSuccessMessageAnimation(successMessage);
        await this.fetchHeaderCounters(); // <-- add this
      } else if (
        response.detail &&
        response.detail.responseMessageCode === "COMPARISON_DUPLICATE"
      ) {
        // Handle duplicate comparison scenario
        console.warn(
          "Product already in comparison list:",
          response.detail.responseData.message
        );

        // Show the error animation with the duplicate message
        this.loadErrorMessageAnimation(
          response.detail.responseData.message ||
            "Product already in comparison list."
        );
      } else {
        console.error("Failed to add product to comparison:", response);
        this.loadErrorMessageAnimation(
          response.message || "Failed to add product to comparison."
        );
      }
    } catch (error) {
  // Check for API error structure
  if (
    error &&
    error.responseMessageCode === "COMPARISON_DUPLICATE"
  ) {
    this.loadErrorMessageAnimation(
      getValueFromLanguageObject("str_product_already_in_comparison") ||
      (error.responseData && error.responseData.message) ||
      "Product already in comparison list."
    );
  } else {
    this.loadErrorMessageAnimation(
      getValueFromLanguageObject("str_error_adding_to_compare") ||
      "An error occurred while adding the product to comparison."
    );
  }
}
  };

  addToWishlistAPI = async (product) => {
    if (!product || !product.id) {
      console.error("Invalid product object passed to wishlist");
      this.loadErrorMessageAnimation("Invalid product data.");
      return;
    }

    const body = {
      productId: product.id,
    };

    try {
      const response = await postCall("v2/wishlists", body);

       if (response.success) {
              const successMessage =
                getValueFromLanguageObject("str_add_to_wishlist_successfully") ||
                response.message ||
                "Product added to wishlist successfully";
              this.loadAddToWishListMessageAnimation(successMessage);
              await this.fetchHeaderCounters(); // <-- add this
            } else if (
              response.detail &&
              response.detail.responseMessageCode === "WISHLIST_DUPLICATE"
            ) {
              const duplicateMessage =
                getValueFromLanguageObject("str_product_already_in_wishlist") ||
                response.detail.responseData.message ||
                "Product already in wishlist.";
              this.loadAddToWishListMessageAnimation(duplicateMessage);
            } else {
              this.loadErrorMessageAnimation(
                response.message || "Failed to add to wishlist"
              );
            }
          } catch (error) {
            console.error("Error in onAddToWishlistClicked:", error);
            this.setState({ isLoading: false });
            this.loadErrorMessageAnimation(
              "An error occurred while adding to wishlist"
            );
          }
  };

  render() {
    const {
      symbol,
      productsNewArrival,
      productsBestSelling,
      masterDetailsObj,
      handleClickOfQuickView,
    } = this.props;
    const {
      isPincodeDeliveryEnable,
      showErrorMessageModal,
      errorMessage,
      showSuccessMessageModal,
      successMessage,
      showAddToWishListMessageModal,
      addToWishListMessage,
    } = this.state;

    return (
      <>
        <section className="section-b-space ratio_square layout-8">
          <div className="container-fluid">
            <div
              className="title2"
              style={{ textAlign: "center", marginBottom: "32px" }}
            >
              <h2
                className="title-inner2"
                style={{
                  display: "inline-block",
                  position: "relative",
                  fontWeight: 600,
                  fontSize: "2rem",
                  color: "#18184a",
                  marginBottom: "0",
                }}
              >
                <span style={{ position: "relative", zIndex: 1 }}>
                  {getValueFromLanguageObject("str_trending_products")
                    ? getValueFromLanguageObject("str_trending_products")
                    : "Trending Products"}
                </span>
              </h2>
            </div>
            <div className="row">
              <div className="col">
                <div className="theme-tab">
                  <Tabs className="theme-tab">
                    <TabList className="tabs tab-title">
                      <Tab>
                        <span>
                          {" "}
                          {getValueFromLanguageObject("str_new_arrival")
                            ? getValueFromLanguageObject("str_new_arrival")
                            : "NEW ARRIVAL"}
                        </span>
                      </Tab>
                      <Tab>
                        <span>
                          {getValueFromLanguageObject("str_best_selling")
                            ? getValueFromLanguageObject("str_best_selling")
                            : "BEST SELLING"}
                        </span>
                      </Tab>
                      {/* <Tab>
                      {getValueFromLanguageObject("str_recently_viewed")
                        ? getValueFromLanguageObject("str_recently_viewed")
                        : "RECENTLY VIEWED"}
                    </Tab> */}
                    </TabList>

                    <TabPanel>
                      <div
                        className="no-slider"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "center",
                          gap: "24px 0",
                          width: "100%",
                          boxSizing: "border-box",
                          padding: 0,
                        }}
                      >
                        {productsNewArrival
                          .slice(0, 8)
                          .map((product, index) => (
                            <ProductItem
                              product={product}
                              symbol={symbol}
                              onAddToCartClicked={(product, qty) => {
                                this.props.addToCart(
                                  product,
                                  qty,
                                  this.props.isInquiry
                                );
                              }}
                              addToWishlistAPI={(product) => {
                                this.addToWishlistAPI(product);
                              }}
                              addToCompareAPI={(product) =>
                                this.addToCompareAPI(product)
                              } // Pass addToCompareAPI as a prop
                              isPincodeDeliveryEnable={isPincodeDeliveryEnable}
                              key={index}
                              masterDetailsObj={masterDetailsObj}
                              handleClickOfQuickView={handleClickOfQuickView}
                            />
                          ))}

                        {/* {productsNewArrival.length === 0 &&
                           (
                            <SpecialProductContentLoaderAnim />
                          )} */}

                        {productsNewArrival.length === 0 && (
                          <NoSpecialProductFoundAnim />
                        )}
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div
                        className="no-slider"
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          justifyContent: "center",
                          gap: "24px 0",
                          width: "100%",
                          boxSizing: "border-box",
                          padding: 0,
                        }}
                      >
                        {productsBestSelling
                          .slice(0, 8)
                          .map((product, index) => (
                            <ProductItem
                              product={product}
                              symbol={symbol}
                              onAddToCartClicked={(product, qty) =>
                                this.props.addToCart(
                                  product,
                                  qty,
                                  this.props.isInquiry
                                )
                              }
                              // onAddToWishlistClicked={(product) => {
                              //   this.props.onAddToWishlistClicked(product);
                              // }}
                              isPincodeDeliveryEnable={isPincodeDeliveryEnable}
                              key={index}
                              masterDetailsObj={masterDetailsObj}
                              handleClickOfQuickView={handleClickOfQuickView}
                            />
                          ))}
                        {/* {productsBestSelling.length === 0 &&
                          isContentLoaderVisible && (
                            <SpecialProductContentLoaderAnim />
                          )} */}

                        {productsNewArrival.length === 0 && (
                          <NoSpecialProductFoundAnim />
                        )}
                      </div>
                    </TabPanel>

                    {/* <TabPanel>
                    <div className=" no-slider row">
                      {productsRecentlyViewed.slice(0, 8).map((product, index) => (
                        <ProductItem
                          product={product}
                          symbol={symbol}
                          onAddToCartClicked={(product, qty) => this.addToCart(product, qty, this.props.isInquiry)}
                          key={index}
                        />
                      ))}
                      {productsRecentlyViewed.length === 0 && <ContentLoaderMain />}
                    </div>
                  </TabPanel> */}
                    <div className="action-item">
                      <Link to={`/products`} className="btn btn-solid">
                        {getValueFromLanguageObject("str_view_all_products")
                          ? getValueFromLanguageObject("str_view_all_products")
                          : "View All Products"}
                      </Link>
                    </div>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </section>
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
        {showSuccessMessageModal && (
          <SuccessMessageAnimationModal
            show={showSuccessMessageModal}
            message={successMessage}
            onClose={() => {
              this.setState({ showSuccessMessageModal: false });
            }}
          />
        )}

        {showAddToWishListMessageModal && (
          <AddToWishListAnim
            show={showAddToWishListMessageModal}
            message={addToWishListMessage}
            onClose={() => {
              this.setState({ showAddToWishListMessageModal: false });
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  isInquiry: state.settings.isInquiry,
  symbol: getCurrencySymbol(),
});

export default connect(mapStateToProps, {
  isInquiryOrCart: isInquiryOrCart,
  setHeaderCounters
})(withRouter(SpecialProducts));
